import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";

import "./index.css";
import "./leaflet-fix";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getTemaApp } from "./tema";
import { BrowserRouter } from "react-router-dom";

function Root() {
    const [mode, setMode] = React.useState(localStorage.getItem("theme") || "light");

    React.useEffect(() => {
        const handleThemeChange = () => {
            setMode(localStorage.getItem("theme") || "light");
        };
        window.addEventListener("theme:updated", handleThemeChange);
        return () => window.removeEventListener("theme:updated", handleThemeChange);
    }, []);

    const theme = React.useMemo(() => getTemaApp(mode), [mode]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ThemeProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);